import * as Dialog from "@radix-ui/react-dialog";

import { Button } from "@/components/ui/button";
import type { MasterControlRedisDryRun } from "@/hooks/useMasterControl";

type DryRunRedisModalProps = {
  open: boolean;
  preview: MasterControlRedisDryRun | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  confirming: boolean;
};

export function DryRunRedisModal({ open, preview, onOpenChange, onConfirm, confirming }: DryRunRedisModalProps) {
  const queues = preview?.queues ?? {};
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/70 backdrop-blur-sm" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-xl -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-border bg-background p-6 shadow-2xl">
          <div className="flex items-start justify-between gap-4">
            <div>
              <Dialog.Title className="text-lg font-semibold text-rose-200">Preview Redis clear</Dialog.Title>
              <Dialog.Description className="text-sm text-muted-foreground">
                Inspect queue lengths that will be flushed.
              </Dialog.Description>
            </div>
            <button
              type="button"
              className="rounded-full border border-border p-1 text-foreground/80 hover:text-primary-foreground dark:text-amber-200"
              onClick={() => onOpenChange(false)}
            >
              ×
            </button>
          </div>
          <div className="mt-4 space-y-3 text-sm text-foreground/80">
            {Object.keys(queues).length === 0 ? (
              <p className="text-muted-foreground">No queue metrics available.</p>
            ) : (
              <dl className="grid gap-4 md:grid-cols-2">
                {Object.entries(queues).map(([name, count]) => (
                  <div key={name} className="rounded-lg border border-border bg-background/30 p-3">
                    <dt className="text-xs uppercase tracking-wide text-muted-foreground">{name}</dt>
                    <dd className="text-xl font-semibold text-foreground">{count}</dd>
                  </div>
                ))}
              </dl>
            )}
          </div>
          <div className="mt-6 flex flex-wrap items-center justify-end gap-3">
            <Button variant="ghost" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              disabled={confirming}
              onClick={() => {
                void onConfirm();
              }}
            >
              {confirming ? "Clearing…" : "Clear queues"}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default DryRunRedisModal;
